const style = {
  attachmentCard: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'start',
    padding: '4px 8px',
    minWidth: '132px',
    width: '132px',
    height: '28px',
    gap: '0px',
    cursor: 'pointer'
  },

  attachmentText: {
    overflow: 'hidden',
    width: '94px',
    display: 'block'
  },

  avatar: {
    marginTop: '4px'
  },

  card: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    gap: '8px', // spacing between Avatar and Text
    padding: '12px 28px',
    border: '1px solid #F5F5F5',
    backgroundColor: '#FFFFFF',
    borderRadius: '0px',
    cursor: 'pointer'
  },

  cardList: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },

  cardTextContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minWidth: 0 // important for text truncation in flex layouts
  },

  emailAttachmentsContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    minWidth: 0,
    overflow: 'hidden',
    marginTop: '6px'
  },

  emailBodyPreviewText: {
    color: '#616161 !important',
    maxHeight: '125px',
    wordBreak: 'break-word'
  },

  emailRowContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '8px'
  },

  emailSubjectDate: {
    flexShrink: 0
  },

  emailCardsContainer: {
    flex: 1,
    overflowY: 'auto',
    width: '100%',
    marginTop: '10px',
    borderTop: '1px solid #F5F5F5',
    borderBottom: '1px solid #F5F5F5'
  }
}

export default style
